import { EditGLDAdditionTask, GLDAdditionTask } from "@nens/brostar/uploadapi-client";
import { SchemaForFormData } from "@nens/shared-utils";

import { getDocsLinkMarkdown, getTitleAddon } from "@/libs/form-utils";
import { FormType } from "@/types/form-types";

import { pickGldLibraryFields } from "../../../schema/gld-schema-library";

const sharedTitle = (type: FormType | undefined) => `GLD-Aanvulling ${getTitleAddon(type)}`;
const sharedDescription = `Dit is het GLD Aanvulling formulier. Gebruik het template om de meetwaardes door te geven. ${getDocsLinkMarkdown(
  "GLD"
)}`;

const getGldAdditionCreateSchema = (
  type: FormType | undefined
): SchemaForFormData<GLDAdditionTask> => ({
  type: "object",
  title: sharedTitle(type),
  description: sharedDescription,
  required: ["metadata", "sourcedocumentData", "timeseriesFile"],
  properties: {
    metadata: {
      type: "object",
      required: ["projectNumber", "broId", "qualityRegime", "deliveryAccountableParty"],
      properties: pickGldLibraryFields([
        "projectNumber",
        "broId",
        "qualityRegime",
        "deliveryAccountableParty",
      ]),
    },
    sourcedocumentData: {
      type: "object",
      required: [
        "processReference",
        "evaluationProcedure",
        "measurementInstrumentType",
        "investigatorKvk",
        "observationType",
        "statusQualityControl",
      ],
      properties: pickGldLibraryFields([
        "processReference",
        "evaluationProcedure",
        "measurementInstrumentType",
        "airPressureCompensationType",
        "investigatorKvk",
        "observationType",
        "statusQualityControl",
      ]),
    },
    ...pickGldLibraryFields(["timeseriesFile"]),
  },
});

const getGldAdditionEditSchema = (
  type: FormType | undefined
): SchemaForFormData<EditGLDAdditionTask> => ({
  type: "object",
  title: sharedTitle(type),
  description: sharedDescription,
  required: ["metadata", "sourcedocumentData", "timeseriesFile"],
  properties: {
    metadata: {
      type: "object",
      required: [
        "projectNumber",
        "broId",
        "qualityRegime",
        "deliveryAccountableParty",
        "correctionReason",
      ],
      properties: {
        ...pickGldLibraryFields([
          "projectNumber",
          "qualityRegime",
          "deliveryAccountableParty",
          "correctionReason",
        ]),
        broId: { ...pickGldLibraryFields(["broId"]).broId, readOnly: true },
      },
    },
    sourcedocumentData: {
      type: "object",
      required: [
        "processReference",
        "evaluationProcedure",
        "measurementInstrumentType",
        "airPressureCompensationType",
        "investigatorKvk",
        "observationType",
        "statusQualityControl",
        "observationId",
      ],
      properties: pickGldLibraryFields([
        "observationId",
        "processReference",
        "evaluationProcedure",
        "measurementInstrumentType",
        "airPressureCompensationType",
        "investigatorKvk",
        "observationType",
        "statusQualityControl",
      ]),
    },
    ...pickGldLibraryFields(["timeseriesFile"]),
  },
});

export function getGldAdditionSchema(args: {
  type: FormType | undefined;
  isEditing: true;
}): SchemaForFormData<EditGLDAdditionTask>;
export function getGldAdditionSchema(args: {
  type: FormType | undefined;
  isEditing: false;
}): SchemaForFormData<GLDAdditionTask>;
export function getGldAdditionSchema(args: {
  type: FormType | undefined;
  isEditing: boolean;
}): SchemaForFormData<EditGLDAdditionTask> | SchemaForFormData<GLDAdditionTask>;
export function getGldAdditionSchema({
  type,
  isEditing,
}: {
  type: FormType | undefined;
  isEditing: boolean;
}) {
  return isEditing ? getGldAdditionEditSchema(type) : getGldAdditionCreateSchema(type);
}
